import { WhichWeightAPI } from 'WhichWeightAPI'
import { useLocation } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { DevicePhoneMobileIcon, CheckIcon } from '@heroicons/react/20/solid'
import moment from 'moment'

import ScreenFrame from 'components/Frame/ScreenFrame'
import MediumLoadingComponent from 'components/Loading/MediumLoadingComponent'

export default function ReportingUserActivity() {
    const location = useLocation()
    const { userId } = location.state

    const [userActivity, setUserActivity] = useState(null)

    const GetUserActivityFromBackend = async () => {
        const jsonBody = {
            userId: userId,
        }

        const result = await WhichWeightAPI('REPORTING', 'GET', '/user_activity', jsonBody)

        // console.log(result);

        setUserActivity(result.data.data)
    }

    useEffect(() => {
        GetUserActivityFromBackend()
    }, [])

    return (
        <ScreenFrame>
            {userActivity === null && <MediumLoadingComponent />}

            {userActivity !== null && (
                <>
                    {/* User Info */}
                    <div className="text-3xl font-semibold">
                        {userActivity.userInfo.firstName} {userActivity.userInfo.lastName}
                    </div>

                    <div className="text-gray-600">{userActivity.userInfo.email}</div>

                    {/* Activity Feed */}
                    <div className="mt-6 border p-4 rounded-lg overflow-hidden bg-white">
                        <ul role="list" className="-mb-8">
                            {userActivity.userActivity.map((activity, index) => (
                                <li key={index}>
                                    <div className="relative pb-8">
                                        {index !== userActivity.length - 1 ? <span className="absolute left-4 top-4 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true" /> : null}

                                        {activity.type === 'login' && (
                                            <div className="relative flex space-x-3">
                                                <span className="h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white bg-gray-400">
                                                    <DevicePhoneMobileIcon className="h-5 w-5 text-white" aria-hidden="true" />
                                                </span>

                                                <div className="flex min-w-0 flex-1 justify-between space-x-4 pt-1.5">
                                                    <p className="text-sm text-gray-500">{userActivity.userInfo.firstName} logged in</p>
                                                    <div className="whitespace-nowrap text-right text-sm text-gray-500">{moment(activity.activityTimestamp).format('MMMM DD, YYYY hh:mm A')}</div>
                                                </div>
                                            </div>
                                        )}

                                        {activity.type === 'workout' && (
                                            <div className="relative flex space-x-3">
                                                <span className="h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white bg-orange-600">
                                                    <CheckIcon className="h-5 w-5 text-white" aria-hidden="true" />
                                                </span>

                                                <div className="flex min-w-0 flex-1 justify-between space-x-4 pt-1.5">
                                                    <p className="text-sm text-gray-500">{userActivity.userInfo.firstName} ran a workout</p>
                                                    <div className="whitespace-nowrap text-right text-sm text-gray-500">{moment(activity.activityTimestamp).format('MMMM DD, YYYY hh:mm A')}</div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </>
            )}
        </ScreenFrame>
    )
}
